module.exports = new __parcel__URL__("train_10_active.19acc283.png").toString();